import { Alert, Button, Card, Icon, notification } from 'antd'
import React, { Component } from 'react'
import { connect, useDispatch } from 'react-redux'
import { ArticleSearch } from '../../../components/ArticleSearch'

import { getUrlParams } from '../../../routes'
// import {
//   articleNoteCountFxn,
//   deleteArticleNote,
//   getArticleById,
//   getNotes,
//   singleArticle
// } from '../actions'
import PageHeaderWrapper from '../../article/ArticleHeader'
import {
  AcceptanceArticleDetails,
  ApprovedArticleDetails,
  ArticleDetails,
  ArticleStatus,
  CommentsToAuthor,
  ComposingDetails,
  DOIDetails,
  GalleyProofDetails,
  OnlineArticleDetails,
  PrintPublication,
  ProcessingCharges,
  PublishArticleDetails,
  ReviewedArticles,
  ReviewerDetails,
  RevisedArticleTable
} from '../../article/articleView/articlePages'
import { getArticleById } from '../../article/actions'
import { getSingleGeneralSubscriptionByIdFxn } from '../action'
import GeneralSubscriptionDetails from './generalSubscriptionDetails'
// Added New Import :-
import { updateGeneralSubscriptionFxn } from '../action/index';

const $ = window.$

class SingleGeneralSubscription extends Component {
  constructor(props) {
    super(props)
    this.state = {
      article: {},
      visibleDrawer: false,
      visibleWithdrawalDrawer: false,
      visibleAddNote: false,
      visibleActivityList: false,
      noteArrived: false,
      totalNotes: 0,
      courierData: []
    }
  }

  componentDidMount() {
    this.loadSingleSubscription('didMount')
    this.reducerStop()
  }

  loadSingleSubscription = async type => {
    this.reducerStop()
    let urlObj = getUrlParams('singleGeneralSubscription', window.location.pathname)
    if (urlObj && urlObj.id) {
      let { error, data } = await this.props.dispatch(getSingleGeneralSubscriptionByIdFxn(urlObj.id))
      console.log("DEBUG: API Response:", data, "Error:", error);
      if (error) {
        notification.error({
          message: 'Error Loading Data'
        })
      } else {
        this.setState({
          article: data,
          courierData: data.courierDetails
        })
      }
    } else {
      notification.error({
        message: 'Error Loading Data'
      })
    }
  }

  componentWillReceiveProps(nextProps, nextContext) {
    if (
      nextProps &&
      nextProps.ArticleReducer &&
      nextProps.ArticleReducer.loadArticle
    ) {
      // this.loadSingleArticle('reloadArticle')
      this.props.dispatch({ type: 'STOP_LOAD_ARTICLE' })
    }
    if (
      nextProps &&
      nextProps.ArticleReducer &&
      nextProps.ArticleReducer.refreshArticle
    ) {
      // this.loadSingleArticle('refreshArticle')
      this.props.dispatch({ type: 'REFRESH_ARTICLE', refreshArticle: false })
    }
  }

  reducerStop = () => {
    this.props.dispatch({ type: 'STOP_LOAD_ARTICLE' })
    this.props.dispatch({ type: 'REFRESH_ARTICLE', refreshArticle: false })
  }
  // loadSingleArticle = async type => {
  //   // console.log(type, '++++++++++')
  //   this.reducerStop()
  //   let urlObj = getUrlParams('articleView', window.location.pathname)
  //   if (urlObj && urlObj.id) {
  //     let { error, data } = await this.props.dispatch(getArticleById(urlObj.id))
  //     if (error) {
  //       notification.error({
  //         message: 'Error Loading Data'
  //       })
  //     } else {
  //       this.setState({ article: data })
  //       document.title = data.articleNo
  //       this.checkArticleNotes(data._id)
  //     }
  //   } else {
  //     notification.error({
  //       message: 'Error Loading Data'
  //     })
  //   }
  // }


  // === PASTE THIS NEW CODE HERE ===
  handleUpdateSubscription = async (updatedData) => {
    // Dispatch the action to Redux/API
    let { error } = await this.props.dispatch(updateGeneralSubscriptionFxn(updatedData._id, updatedData));

    if (!error) {
      notification.success({ message: 'Details Updated Successfully' });
      this.loadSingleSubscription(); // This refreshes the page data
      return true;
    } else {
      notification.error({ message: 'Update Failed' });
      return false;
    }
  }
  // === END PASTE ===

  render() {
    let { article, totalNotes, noteArrived } = this.state
    return (
      <PageHeaderWrapper
        className={'articleHeader'}
        title={
          <div className={'sticky-header'}>
            <div className={'headerPanel'}>
              <div className={'titleDiv'}>
                <ArticleSearch />
                Journal Subscription Details
              </div>


            </div>
          </div>
        }>

        {/*<ArticleStatus article={article} />*/}
        <GeneralSubscriptionDetails article={this.state.article} courierData={this.state.courierData} reloadData={() => this.loadSingleSubscription()}
          onUpdate={this.handleUpdateSubscription} />

      </PageHeaderWrapper>
    )
  }
}

const mapStateToProps = ({ global, router, ArticleReducer }) => ({
  search: router.location.search,
  pathname: router.location.pathname,
  ArticleReducer: ArticleReducer
})
const mapDispatchToProps = dispatch => {
  return {
    dispatch
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SingleGeneralSubscription)
